import dashboardApi from '@/services/dashboard';
import { timeFormat } from '@/shared/utils';
import { Table } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
const Root = styled.div ``;
const MyTodo = ({ className, style }) => {
    const columns = [
        {
            title: '审核内容',
            dataIndex: 'content',
            key: 'content',
            width: '40%',
        },
        {
            title: '发起人',
            dataIndex: 'approver',
            key: 'approver',
            width: '10%',
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            render: (text) => {
                return moment(text).format(timeFormat.secondFormat);
            },
            width: '30%',
        },
        {
            title: '操作',
            dataIndex: 'referenceUrl',
            width: '20%',
            render: (referenceUrl, record) => {
                return (<a onClick={() => {
                    window.open(`${referenceUrl}`);
                }}>
            去审批
          </a>);
            },
        },
    ];
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(true);
    const sortData = (a, b) => {
        if (moment(b.createTime).isAfter(moment(a.createTime))) {
            return 1;
        }
        else {
            return -1;
        }
    };
    useEffect(() => {
        dashboardApi.fetchMyTodo().promise.then(res => {
            setDataSource(res.sort(sortData));
            setLoading(false);
        });
    }, []);
    return (<Root className={className} style={style}>
      <Table columns={columns} dataSource={dataSource} loading={loading} rowKey={'referenceUrl'} scroll={{ y: 412 }} locale={{
        emptyText: '您没有待办任务',
    }}/>
    </Root>);
};
export default MyTodo;
